import type { LimitOrder } from '../model'
import type { TransKey } from '@root/shared/localization'

export const LIMIT_ORDER_STATUS_COLOR_MAP: Record<LimitOrder.Status, string> = {
  active: 'var(--successAccent-9)',
  cancelled: 'var(--errorAccent-9)',
  failed: 'var(--errorAccent-9)',
  completed: 'var(--primary-9)',
  expired: 'var(--errorAccent-9)',
}

export const LIMIT_ORDER_STATUS_LABEL_MAP: Record<LimitOrder.Status, TransKey> =
  {
    active: 'limit_order.status_active',
    cancelled: 'limit_order.status_cancelled',
    failed: 'limit_order.status_failed',
    completed: 'limit_order.status_completed',
    expired: 'limit_order.status_expired',
  }

export const LIMIT_ORDER_STATUS_DATE_MAP: Record<LimitOrder.Status, TransKey> =
  {
    active: 'trade.expire-date',
    cancelled: 'trade.cancelled-at',
    completed: 'trade.completed-at',
    failed: 'trade.failed-at',
    expired: 'trade.expired-at',
  }
